import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderModule } from '../loader/loader.module';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { CalenderComponent } from 'src/app/view/calender/calender.component';
import { TwotwoTwothreeComponent } from 'src/app/view/calender/twotwo-twothree/twotwo-twothree.component';
import { TwoFiveTwoSixComponent } from 'src/app/view/calender/two-five-two-six/two-five-two-six.component';
import { TwoSixTwoSevenComponent } from 'src/app/view/calender/two-six-two-seven/two-six-two-seven.component';



@NgModule({
  declarations: [
    CalenderComponent,
    TwotwoTwothreeComponent,
    TwoFiveTwoSixComponent,
    TwoSixTwoSevenComponent
  ],
  imports: [
    CommonModule,
    LoaderModule,
    SharedModule,
    RouterModule.forChild([
      {
        path: '', component: CalenderComponent, children: [
          { path: '2022-23', component: TwotwoTwothreeComponent },
          { path: '2025-26', component: TwoFiveTwoSixComponent },
          { path: '2026-27', component: TwoSixTwoSevenComponent }
        ]
      }
    ])
  ]
})
export class CalenderModule { }
